import type { JSX } from 'react';
import { useState } from 'react';
import type { SaveDoc } from '@bratva/state';

interface Props {
  save: SaveDoc;
}

/**
 * Первые два дня: подсказки не по расписанию, а по состоянию.
 * Каждая исчезает сама, как только игрок сделал то, о чём она говорит, —
 * поэтому туториал нельзя «пройти мимо».
 */
function currentHint(save: SaveDoc): string | null {
  if (save.day > 2) return null;

  if (save.habar.length === 0 && (save.counters['jobs'] ?? 0) === 0) {
    return 'Во дворе и у гаражей стоят чужие тачки. Кликни по одной — подойдёшь и посмотришь, что с ней можно.';
  }
  if (save.habar.length > 0) {
    return 'В руках краденое. Приёмка во дворе заберёт всё и оставит себе тридцать процентов — зато палево спадёт.';
  }
  if (save.businesses.length === 0 && save.player.cash < 250000) {
    return 'Копи на ларёк: своя точка капает, пока ты спишь. Это первое, что превращает мелочь в доход.';
  }
  if (save.businesses.length === 0) {
    return 'Денег хватает: во дворе есть ларёк. Кликни по нему и выкупи — дальше он работает сам.';
  }
  if (save.player.stress >= 55) {
    return 'Нервы на пределе, а от стресса падают шансы. Мамка у подъезда кормит котлетами раз в день.';
  }
  if (save.player.heat >= 40) {
    return 'Палево растёт. Патрули видно на карте: держись от них подальше, когда идёшь на дело.';
  }
  return 'Двадцать три ноль-ноль — конец дня. Кнопка «Спать» перематывает ночь: палево спадёт, точки принесут доход.';
}

export function Tutorial({ save }: Props): JSX.Element | null {
  const [hidden, setHidden] = useState(false);
  const hint = currentHint(save);

  if (hidden || !hint || save.outcome !== 'active') return null;

  return (
    <div className="tutorial">
      <p>{hint}</p>
      <button type="button" onClick={() => setHidden(true)} aria-label="Скрыть подсказки">
        Понятно
      </button>
    </div>
  );
}
